
    import { reactive, ref, watch, onMounted, computed } from 'vue';
    import SearchModel from '@Apps/Search/Src/Models/SearchModel';
    import { FilterModel } from '@Apps/Search/Src/Models/FilterModel';

    import * as searchComposables from '@Composables/SearchComposables';
    import { toUrl as filterToQuery } from '@Apps/Search/Src/Logic/urlConvert';
    import { setupSearchModel } from '@Apps/Search/Src/Logic/setupSearchModel';
    import { setupCombinedFilter } from "@Components/SearchFilter/setupFilterAndBarComposables"
    import { setup as fetchSearchSetup, fetchPage, IFetchSearchResult, createSearchUrl, CreateSearchUrlType } from '@Composables/FetchSearchComposables';
    import { addHistoryOnClick } from '@Apps/Search/Src/Logic/historyLogic';
    import scrollToTop from '@Apps/Search/Src/Logic/scrollToTop';

    import appTranslations from '@Apps/Search/Translations/VueTranslations';


    import SearchFilter from '@Components/SearchFilter/SearchFilterComponent.vue';
    import SearchFilterBar from '@Components/SearchFilterBar/SearchFilterBarComponent.vue';
    import PagingControl from '@Apps/Search/Src/Components/PagingControl.vue';

    import ICombinedFilterComponent from '@Components/CombinedFilter/ICombinedFilterComponent';
    import { setupFilterWatch } from '@Apps/MapSearch/Src/Components/MapSearch/Composables/SetupFilterWatchesComposables';

    export default {

        // note that props on an app are not 'default'
        // these are created in the main.ts, and are retrieved from all data- attributes
        // on the html element that serves as the root for the app.
        // all values would be string by default!
        props: {


        },

        components: { SearchFilter, SearchFilterBar, PagingControl },


        setup(props: any) {


            // containers for search results (as html, server side rendering)
            const searchAppContainer = ref<HTMLElement | null>(null);
            const searchPageBody = ref<HTMLElement | null>(null);
            const searchResults = ref<HTMLElement | null>(null);
            const altResults = ref<HTMLElement | null>(null);



            const filterInstance = ref<ICombinedFilterComponent | null>(null);


            let searchModel = reactive(setupSearchModel()) as SearchModel;

            const totalCount = computed(() => searchModel.totalCount);



            // do setup for combined filter, note that we need a ref for the component
            const { isFilterVisible, onHideFilter, onSearchBarAction } = setupCombinedFilter(filterInstance);


            // do setup for fetch calls,
            // we explicitly state the handling here.
            const { stateIsFetching, triggerNewSearch } = fetchSearchSetup(searchModel, (data: IFetchSearchResult) => {

                // convert data to specific implementation for default search
                // which will include the content and alt props as html..
                const castData = data as any; // todo: specific type here

                if (searchResults.value !== null) {
                    searchResults.value.innerHTML = castData.content;
                }

                if (altResults.value !== null) {
                    altResults.value.innerHTML = castData.alt;
                }

            });


            // note that we only watch the filter here, not the entire search Model.
            setupFilterWatch(searchModel.filter, triggerNewSearch, false, null, false, null);


            //we watch the is fetching to add class to app container

            watch(stateIsFetching, (newVal, oldVal) => {

                if (searchAppContainer.value !== null) {

                    if (newVal) {
                        searchAppContainer.value.classList.add("is-searching");
                    } else {
                        searchAppContainer.value.classList.remove("is-searching");
                    }
                }

            });

            watch(isFilterVisible, (newVal, oldVal) => {

                if (searchPageBody.value !== null) {

                    if (newVal) {
                        searchPageBody.value.classList.add("is-filter-visible");
                    } else {
                        searchPageBody.value.classList.remove("is-filter-visible");
                    }
                }

            });



            const pageTo = (page: number) => {

                fetchPage(page);
                scrollToTop(true);

            };

            const clearLandingPageFilters = () => {


                // for now we do a clear all
                searchComposables.clearFiltersAndRedirect();

            };


            const onShowMapClicked = () => {

                const search = filterToQuery(searchModel.filter);

                // note that this creates the complete url,
                // including any landing pages or provider pages.
                // as used in 'paging' and
                const url = createSearchUrl(search, CreateSearchUrlType.switch, false);

                window.location.assign(url);
            }



            onMounted(() => {

                // workaround because the elements are not in vue, but rendered server side (so cannot teleport).

                // todo: validate correct element ids

                searchAppContainer.value = document.getElementById("search-app-container");
                searchPageBody.value = document.getElementsByTagName('body')[0];
                searchResults.value = document.getElementById("results-container");
                altResults.value = document.getElementById("alternatives-container");

                // todo: test is this works!

                addHistoryOnClick(searchResults.value!, searchModel.filter, searchComposables.clearFiltersAndRedirect);



            });

            return {
                filterInstance,

                onShowMapClicked,
                searchModel,
                totalCount,

                stateIsFetching,
                scrollToTop,
                pageTo,
                clearLandingPageFilters,

                isFilterVisible, onHideFilter, onSearchBarAction,


                resx: appTranslations

            }
        }

    };



